import { Button } from "@/components/ui/button";
import { Facebook, Twitter, Instagram, Linkedin, BookOpenText } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const SocialIcons = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-center gap-4">
      <Button 
        variant="ghost" 
        size="icon"
        className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
        onClick={() => window.open('https://www.facebook.com/profile.php?id=61556743824804', '_blank')}
        aria-label="Visit our Facebook page"
      >
        <Facebook className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon"
        className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
        onClick={() => window.open('https://x.com/PorteroYa', '_blank')}
        aria-label="Visit our X (Twitter) profile"
      >
        <Twitter className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon"
        className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
        onClick={() => window.open('https://www.instagram.com/porteroyaoficial/', '_blank')}
        aria-label="Visit our Instagram profile"
      >
        <Instagram className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon"
        className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
        onClick={() => window.open('https://www.linkedin.com/company/porteroya', '_blank')}
        aria-label="Visit our LinkedIn page"
      >
        <Linkedin className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon"
        className="h-8 w-8 hover:text-primary active:text-secondary transition-colors duration-200 text-gray-900"
        onClick={() => navigate("/blog")}
        aria-label="Visit our blog"
      >
        <BookOpenText className="h-4 w-4" />
      </Button>
    </div>
  );
};